document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.product-tabs').forEach(section => {

    const tabs = section.querySelectorAll('.product-tabs__tab');
    const panels = section.querySelectorAll('.product-tabs__panel');

    // DESKTOP TABS
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tab;

        tabs.forEach(t => t.classList.remove('is-active'));
        panels.forEach(p => p.classList.remove('is-active'));

        tab.classList.add('is-active');
        section.querySelector(`[data-panel="${target}"]`).classList.add('is-active');
      });
    });

    // MOBILE ACCORDION
    panels.forEach(panel => {
      const titleMap = {
        description: 'Product Description',
        features: 'Key Product Features',
        specs: 'Product Specification',
        manufacturer: 'About Manufacturer'
      };

      panel.setAttribute('data-panel-title', titleMap[panel.dataset.panel]);

      panel.addEventListener('click', () => {
        if (window.innerWidth > 768) return;
        panel.classList.toggle('is-open');
      });
    });

  });

});